/**
 * [INPUT]: 依赖同模块代码与项目公共基础设施能力
 * [OUTPUT]: 对外提供 channelUserId 相关实现
 * [POS]: 位于 jeepay-ui\jeepay-ui-cashier\src\utils，工具层实现，负责通用函数与基础能力复用
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
/**
 * 获取渠道用户 工具类
 *
 * @author terrfly
 * @site https://www.jeepay.vip
 * @date 2021/5/8 07:18
 */
const getChannelUserId = function () {
    return localStorage.getItem("channelUserId")
}

const setChannelUserId = function (channelUserId) {
    localStorage.setItem("channelUserId", channelUserId)
}

export default {
    getChannelUserId: getChannelUserId,
    setChannelUserId: setChannelUserId
}
